import FullscreenProgressIndicator from "./FullscreenProgressIndicator";
import useFullscreenProgressIndicator from './useFullscreenProgressIndicator';

export default FullscreenProgressIndicator;
export { useFullscreenProgressIndicator };